import { setPaymentPopup, useSoftUIController } from "context";
import useAuth from "layouts/authentication/hooks/useAuth";
import popUP from "../../assets/images/popUP.png";

export default ({ onClick }) => {
	const { auth } = useAuth();
	const [controller, dispatch] = useSoftUIController();
	const { paymentPopup } = controller;

	return (
		<div>
			<input
				type="image"
				id="saveform"
				src={popUP}
				className="icon"
				style={{ width: "30px" }}
				alt="Submit Form"
				onClick={() => {
					if (!auth || !auth.plan?.plan_features.available.includes("gem_options_ranking")) {
						setPaymentPopup(dispatch, {
							forStocks: false,
							on: !paymentPopup.on,
							isPaymentPopup: true,
						});
					} else if (onClick) onClick();
				}}
			></input>
		</div>
	);
};
